import React, { Component } from 'react';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntLocalization from '../utils/AntLocalization';

export default class AntTitlePanel extends Component {
    render() {
        var className = 'ant-title-text';
        if (this.props.center) className = className + '-center';
        if (this.props.upper) className = className + '-upper';
        return (
            <React.Fragment>
                {this.props.text && (
                    <div className="ant-title-pannel">
                        <Box direction="row" height="100%" width="100%">
                            <BoxItem ratio={1}>
                                <span className={className}>{AntLocalization.translateText(this.props.text)}</span>
                            </BoxItem>
                        </Box>
                    </div>
                )}
            </React.Fragment>
        );
    }
}
